import { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "../auth/AuthContext"; // Importação para sincronizar com o logout

const AtendimentoContext = createContext();

export const AtendimentoProvider = ({ children }) => {
  // 1. Inicializa lendo do sessionStorage para sobreviver ao F5 na tela
  const [atendimentoId, setAtendimentoIdState] = useState(() => {
    return sessionStorage.getItem("@advger:atendimentoId") || null;
  });

  const { user } = useAuth() || {};

  // 2. Atualiza tanto o Estado do React quanto o Storage da sessão
  const setAtendimentoId = (id) => {
    if (id) {
      sessionStorage.setItem("@advger:atendimentoId", id);
      setAtendimentoIdState(id);
    } else {
      limparAtendimento();
    }
  };

  // 3. Limpa o ID do atendimento atual
  const limparAtendimento = () => {
    sessionStorage.removeItem("@advger:atendimentoId");
    setAtendimentoIdState(null);
  };

  // 4. Limpa o atendimento ativo se o usuário fizer logout
  useEffect(() => {
    if (!user) {
      limparAtendimento();
    }
  }, [user]);

  return (
    <AtendimentoContext.Provider
      value={{
        atendimentoId,
        setAtendimentoId,
        limparAtendimento,
      }}
    >
      {children}
    </AtendimentoContext.Provider>
  );
};

export const useAtendimentoAtual = () => {
  const context = useContext(AtendimentoContext);
  if (!context) {
    throw new Error("useAtendimentoAtual deve ser usado dentro de um AtendimentoProvider");
  }
  return context;
};